import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { InputBase, IconButton, Box, styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useDebounce } from "hooks/debounce";

const SearchWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  border: "1px solid rgba(0, 0, 0, 0.15)",
  borderRadius: theme.shape.borderRadius,
  width: 320,
  height: 35,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  flex: 1,
  marginLeft: theme.spacing(0.5),
  fontSize: "0.875rem",
}));

const CustomSearchInput = ({ paramKey, placeholder = "", sx }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get(paramKey) || "";

  const [searchValue, setSearchValue] = useState(initialSearch);
  const debouncedSearch = useDebounce(searchValue, 600);

  const updateURL = (value) => {
    const newParams = new URLSearchParams(searchParams);
    if (value.trim()) {
      newParams.set(paramKey, value);
    } else {
      newParams.delete(paramKey);
    }
    setSearchParams(newParams, { replace: true });
  };

  useEffect(() => {
    updateURL(debouncedSearch);
  }, [debouncedSearch]);

  const handleClear = () => {
    setSearchValue("");
    updateURL("");
  };

  return (
    <SearchWrapper sx={sx}>
      <SearchIcon sx={{ fontSize: 18, color: "text.secondary" }} />
      <StyledInputBase
        type="text"
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      {searchValue && (
        <IconButton size="small" onClick={handleClear} sx={{ p: 0.25 }}>
          <ClearIcon sx={{ fontSize: 16, color: "text.secondary" }} />
        </IconButton>
      )}
    </SearchWrapper>
  );
};

export default CustomSearchInput;
